import axios from "axios";

const API_URL = process.env.REACT_APP_BASEURL;

export const getAdSubmissions = async (status, is_approved) => {
  try {
    const response = await axios.get(`${API_URL}/get-adsubmissionscms`, {
      params: {
        status,
        is_approved,
      },
    });
    if (response.data.success) {
      return response.data.data;
    } else {
      console.error("Failed to fetch ad submissions:", response.data.message);
      return [];
    }
  } catch (error) {
    console.error("Error fetching ad submissions:", error);
    return [];
  }
};
